import {
  startOfQuarter,
  endOfQuarter,
  subQuarters,
  addQuarters,
  format,
} from "date-fns";

const lastQuarterToCurrenQuarter = (value) => {
  const currentDate = new Date();

  // Calculate the start of the quarter "value" quarters ago
  const startDate = startOfQuarter(subQuarters(currentDate, Number(value) - 1));

  // Calculate the end of the current quarter
  const endDate = endOfQuarter(currentDate);

  const formattedStartDate = format(startDate, "dd/MM/yyyy");
  const formattedEndDate = format(endDate, "dd/MM/yyyy");
  const dates = { formattedStartDate, formattedEndDate };
  return dates;
};

const currentQuarterToNextQuarter = (value) => {
  const currentDate = new Date();

  // Calculate the start of the current quarter
  const startDate = startOfQuarter(currentDate);

  // Calculate the end of the Nth quarter in the future
  const endDate = endOfQuarter(addQuarters(currentDate, Number(value) - 1));

  const formattedStartDate = format(startDate, "dd/MM/yyyy");
  const formattedEndDate = format(endDate, "dd/MM/yyyy");
  const dates = { formattedStartDate, formattedEndDate };
  return dates;
};

const fromThisQuarterToThisQuarter = (value) => {
  const currentDate = new Date();

  let startDate;
  let endDate;

  if (value === "Last Quarter") {
    startDate = startOfQuarter(subQuarters(currentDate, 1)); // Start of last quarter
    endDate = endOfQuarter(subQuarters(currentDate, 1)); // End of last quarter
  } else if (value === "This Quarter") {
    startDate = startOfQuarter(currentDate); // Start of this quarter
    endDate = endOfQuarter(currentDate); // End of this quarter
  } else if (value === "Next Quarter") {
    startDate = startOfQuarter(addQuarters(currentDate, 1)); // Start of next quarter
    endDate = endOfQuarter(addQuarters(currentDate, 1)); // End of next quarter
  } else {
    console.error(
      "Invalid value, please use 'Last Quarter', 'This Quarter', or 'Next Quarter'"
    );
  }

  // Format the dates
  if (startDate && endDate) {
    const formattedStartDate = format(startDate, "dd/MM/yyyy");
    const formattedEndDate = format(endDate, "dd/MM/yyyy");
    return { formattedStartDate, formattedEndDate };
  } else {
    // console.log("start and end date is undefined");
  }
};

export {
  lastQuarterToCurrenQuarter,
  currentQuarterToNextQuarter,
  fromThisQuarterToThisQuarter,
};
